import styled from 'styled-components';

export const Tooltip = styled.div`
  visibility: hidden;
  position: absolute;
  left: 0;
  top: 25px;
  min-width: 285px;
  background: rgb(50 61 76 / 80%);
  color: var(--white);
  text-align: center;
  padding: 5px 5px;
  font-size: 11px;
  line-height: 1.2;
  font-family: var(--secondary-font), sans-serif;
  border-radius: 4px;
  z-index: 1;
  transition: all 0.3s ease 0.25s;
`;

export const Badge = styled.div`
  position: relative;
  font-size: 11px;
  line-height: 1.1em;
  text-transform: uppercase;
  display: inline-flex;
  align-items: center;
  padding: 4px 8px;
  border-radius: 4px;

  &.default {
    color: var(--carbone80);
    background: var(--aluminium20);
  }

  &.success {
    background: var(--green10);
    color: #0b6d26;
  }

  &.warning {
    background: var(--red10);
    color: #922b13;
  }

  &.feature {
    color: var(--theme-palette-feature-color);
    background: var(--theme-palette-feature-bg);
  }

  &.aux {
    color: var(--yellow120);
    background: var(--yellow10);
  }
`;

export const ExtBadge = styled(Badge)`
  > svg {
    z-index: 0 !important;
  }

  &:hover {
    ${Tooltip} {
      visibility: visible;
    }
  }
`;
